import React, { ReactNode } from "react";
import HPButton from "./Button";

interface FormModalProps {
  title: string | ReactNode;
  children: ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  confirmButtonIcon?: ReactNode;
  headerIcon?: ReactNode;
  loading?: boolean;
  isConfirmButtonDisabled?: boolean;
}

const FormModal: React.FC<FormModalProps> = ({
  title,
  children,
  cancelButtonText = "Cancel",
  confirmButtonText = "Confirm",
  onCancel,
  onConfirm,
  confirmButtonIcon,
  headerIcon,
  loading,
  isConfirmButtonDisabled = false,
}) => {
  const hasCancelButton = !!cancelButtonText && !!onCancel;
  const hasConfirmButton = !!confirmButtonText && !!onConfirm;

  return (
    <div
      className={`bg-white w-full rounded-lg shadow-lg flex flex-col mx-auto min-w-[540px]`}
    >
      <div className="p-6 flex gap-1 items-center">
        {headerIcon} <h2 className="text-lg font-semibold">{title}</h2>
      </div>
      <div className="text-sm border-t border-b border-hp-border-default">
        <div className="p-6 flex flex-col gap-4 max-h-[80vh] overflow-auto">
          {children}
        </div>
      </div>
      <div className="flex justify-end gap-1 p-4">
        {hasCancelButton && (
          <HPButton
            ariaLabel="Cancel"
            variant="text"
            size="medium"
            onClick={onCancel}
            className="text-hp-text-day-primary"
          >
            {cancelButtonText}
          </HPButton>
        )}
        {hasConfirmButton && (
          <HPButton
            disabled={isConfirmButtonDisabled}
            loading={loading}
            startIcon={confirmButtonIcon}
            ariaLabel="Confirm"
            variant="contained"
            size="medium"
            onClick={onConfirm}
          >
            {confirmButtonText}
          </HPButton>
        )}
      </div>
    </div>
  );
};

export default FormModal;
